import { render, staticRenderFns } from "./AvaliacaoPreOperatoriaResumo.vue?vue&type=template&id=97ff8756&scoped=true"
import script from "./AvaliacaoPreOperatoriaResumo.vue?vue&type=script&lang=ts"
export * from "./AvaliacaoPreOperatoriaResumo.vue?vue&type=script&lang=ts"
import style0 from "./AvaliacaoPreOperatoriaResumo.vue?vue&type=style&index=0&id=97ff8756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ff8756",
  null
  
)

export default component.exports